import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base-components/base-component.component';
import { Subject } from 'rxjs';
import { ValidationHandlerService } from '../../services/validation-handler.service';
import { LanguageService } from '../../services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ActivityLogStatus,  StravaActivityLogListModel } from '../../services/api-services';

@Component({
    selector: 'app-retry-view',
    template: `
        <div class="d-flex flex-row gap-1">
            <button class="d-flex gap-2 align-items-center action-button" (click)="onViewItem()">
                <img class="icon" src="assets/icon/search.png" />
            </button>
            <button *ngIf="canShowRetryButton" class="btn btn-secondary btn-sm py-1 d-flex gap-2 align-items-center action-button" (click)="onRetryItem()">
                {{ 'activity.retry_button_title' | translate }}
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `,
    ],
})
export class RetryViewComponent extends BaseComponent {
    constructor(protected override modalService: BsModalService, private router: Router, protected override spinnerService: NgxSpinnerService, protected translateService: TranslateService, protected override languageService: LanguageService, protected override validationHandlerService: ValidationHandlerService) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }

    get canShowRetryButton(): boolean {
        if (this.data.status === ActivityLogStatus.Success) {
            return false;
        }
        return (
            this.data.status === ActivityLogStatus.FailedNotSupportedType ||
            this.data.status === ActivityLogStatus.FailedStravaNotAvailable
        );
    }


    @Output()
    emitter = new Subject<{ action: string; data: any }>();

    @Input()
    data: StravaActivityLogListModel = {};

    ngOnInit() {

        console.log(this.data)
    }

    onRetryItem() {
        this.emitter.next({
            action: 'retry',
            data: this.data,
        });
    }

    onViewItem() {
        this.emitter.next({
            action: 'view',
            data: this.data,
        });
    }
}
